import "./Chat.css";

export default function Chat({ chat, SelectChat }) {
  const chatCurrent = chat || {};

  const chatUsers = chatCurrent?.chatUserList || [];
  const firstUser = chatUsers[1] || { name: "Usuário", profileUrl: "" };

  const lastMessage =
    chatCurrent?.chatLineList?.length > 0
      ? chatCurrent.chatLineList[chatCurrent.chatLineList.length - 1].text
      : "Sem mensagens...";

  return (
    <div className="chat-item" onClick={() => SelectChat(chatCurrent)}>
      <img
        className="chat-avatar"
        src={firstUser?.profileUrl || "https://img.icons8.com/ios/452/user-male-circle.png"}
        alt="avatar"
      />

      <div className="chat-info">
        <div className="chat-name">{firstUser?.name}</div>
        <div className="chat-last-message">{lastMessage}</div>
      </div>
    </div>
  );
}